<template>
    <div style="position: relative;height: auto;overflow: hidden;min-height: 100vh;margin-bottom: 50px;">
        <div class="bar" id="barId"></div>
        <div class="freeback" v-show="freebackShow">
            <div class="freebackText">对吉林一号遥感影像套件有更多建议和期许？快告诉我们吧！ <span style="cursor: pointer;" @click="$router.push('/Feedback');">点击反馈 ></span></div>
            <div class="freebackBlue" id="freebackBlueId">
                <img src="~@/assets/newHome/反馈关闭.png" alt="" class="freebackClose" @click="freebackShow=false">
            </div>
        </div>
        <div class="navi">
            <div class="naviContent"><span @click="$router.push('/');" style="cursor: pointer;">首页</span> / 我的套件</div>
        </div>
        <div class="enterprise" id="enterpriseId">
            <div class="textType3">您的账户中有 {{rsNum}} 个套件</div>
            <div v-for="(item, index) in dataList" :key="index">
                <!-- 企业版 -->
                <div class="type3Grey" v-if="item.type==1">
                    <img src="~@/assets/newHome/all_year.png" alt="" class="basisTitle" v-if="item.repSubName=='2023年全年'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/all_year.png" alt="" class="basisTitle" v-if="item.repSubName=='2024年全年'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q1.png" alt="" class="basisTitle" v-if="item.repSubName=='2023第一季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q1.png" alt="" class="basisTitle" v-if="item.repSubName=='2024第一季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q2.png" alt="" class="basisTitle" v-if="item.repSubName=='2023第二季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q2.png" alt="" class="basisTitle" v-if="item.repSubName=='2024第二季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q3.png" alt="" class="basisTitle" v-if="item.repSubName=='2023第三季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q3.png" alt="" class="basisTitle" v-if="item.repSubName=='2024第三季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q4.png" alt="" class="basisTitle" v-if="item.repSubName=='2023第四季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q4.png" alt="" class="basisTitle" v-if="item.repSubName=='2024第四季度'&&item.expireStatus!=2">
                    <img src="~@/assets/newHome/Q5.png" alt="" class="basisTitle" v-if="item.expireStatus==2">
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2023年全年'">企业版-2023全年版</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2024年全年'">企业版-2024全年版</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2023第一季度'">企业版-2023第一季度</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2024第一季度'">企业版-2024第一季度</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2023第二季度'">企业版-2023第二季度</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2024第二季度'">企业版-2024第二季度</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2023第三季度'">企业版-2023第三季度</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2024第三季度'">企业版-2024第三季度</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2023第四季度'">企业版-2023第四季度</div>
                    <div class="basisText1" style="color: #fff;font-weight: 400;" v-if="item.repSubName=='2024第四季度'">企业版-2024第四季度</div>
                    <div class="greyText1" style="top: 70px;">2023年全国高质量一张图</div>
                    <div class="greyText2" style="top: 100px;">分辨率：0.5m</div>
                    <div class="greyText2" style="top: 130px;">有效数据覆盖率：99%</div>
                    <div class="greyText2" style="top: 160px;">切片等级：18级</div>
                    <div class="greyText1" style="top: 210px;">全球一张图</div>
                    <div class="greyText2" style="top: 240px;">分辨率：优于0.75m(含)</div>
                    <div class="greyText2" style="top: 270px;">有效数据覆盖率：100%</div>
                    <div class="greyText2" style="top: 300px;">切片等级：18级</div>
                    <div class="greyText1" style="top: 350px;">2022每季度(试点)县域一张图</div>
                    <div class="greyText2" style="top: 380px;">分辨率：优于0.75m(含)</div>
                    <div class="greyText2" style="top: 410px;">有效数据覆盖率：100%</div>
                    <div class="greyText2" style="top: 440px;">切片等级：18级</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2023年全年'">2023年各季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2024年全年'">2024年各季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2023第一季度'">2023年第一季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2024第一季度'">2024年第一季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2023第二季度'">2023年第二季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2024第二季度'">2024年第二季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2023第三季度'">2023年第三季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2024第三季度'">2024年第三季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2023第四季度'">2023年第四季度全国一张图</div>
                    <div class="greyText1" style="top: 490px;" v-if="item.repSubName=='2024第四季度'">2024年第四季度全国一张图</div>
                    <div class="greyText2" style="top: 520px;">分辨率：优于0.75m(含)</div>
                    <div class="greyText2" style="top: 550px;">有效数据覆盖率：100%</div>
                    <div class="greyText2" style="top: 580px;">切片等级：18级</div>
                    <div class="greyText2" style="top: 610px;">调用面积：10万km²</div>
                    <div class="greyText2" style="top: 640px;">合计调用次数限制：300万次/日</div>
                    <div class="greyLine1"></div>
                    <div class="greyArea1">
                        <div class="greyAreaText1">订单编号：{{ item.id }}</div>
                        <div class="greyAreaText1" v-if="item.redemptionType==0">下单时间：{{ item.createTime }}</div>
                        <div class="greyAreaText1" v-if="item.redemptionType==1">兑换时间：{{ item.createTime }}</div>
                        <div class="greyAreaText1" v-if="item.status=='待付款'&&item.redemptionType==0">购买时间：{{ item.purchaseTime }}</div>
                        <div class="greyAreaText1" v-if="item.status=='已付款'&&item.redemptionType==0">交付时间：{{ item.purchaseTime }}</div>
                        <div class="greyAreaText1" v-if="item.redemptionType==1">兑换码：{{ item.redemptionCode }}</div>
                        <div class="greyAreaText1" v-if="item.redemptionType==1">代理商联系人：{{ item.agentName }}</div>
                        <div :class="item.expireStatus=='1' ? 'greyAreaText1-s' : 'greyAreaText1'" v-if="item.status!='审核中'&&item.status!='合同待确认'">有效期至：{{ item.endTime }}</div>
                        <div class="greyAreaText1" v-if="item.status!='审核中'&&item.status!='合同待确认'">剩余调用面积：<span style="color:#1E81EB;font-weight: 600;" v-if="item.redemptionType!=2&&remainAreaList[index].remainArea!=null">{{ remainAreaList[index].remainArea.toFixed(2) }}</span> km²</div>
                        <div class="greyAreaText1" v-if="item.status!='审核中'&&item.status!='合同待确认'">当日剩余调用次数：<span style="color:#1E81EB;font-weight: 600;" v-if="item.redemptionType!=2">{{ item.todayFlowSum }}</span></div>
                        <div class="greyAreaText1" v-if="item.status=='审核中'">订单状态：审核中</div>
                        <div class="greyAreaText1" v-if="item.status=='合同待确认'">订单状态：合同已生成  &nbsp;待确认 &nbsp; <span style="color:#1E81EB ;cursor: pointer;" @click="followOrder(item.status,item.id,1)">去确认</span></div>
                        <div class="greyAreaText1" v-if="item.status=='待付款'">订单状态：合同已确认 &nbsp; 待付款 &nbsp;</div>
                        <div class="greyAreaText1" v-if="item.status!='审核中'&&item.status!='合同待确认'" style="margin-top: 20px;">
                            <div class="greyText1" style="top: 0px;left: 0px;">Web端工具集SDK(V1.0.0)</div>
                            <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(1)">使用手册</div>
                            <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(4)">下载SDK</div>
                        </div>
                        <div class="greyAreaText1" v-if="item.status!='审核中'&&item.status!='合同待确认'">
                            <div class="greyText1" style="top: 0px;left: 0px;">移动端工具集SDK(V1.0.0)</div>
                            <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(2)">使用手册</div>
                            <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(5)">下载SDK</div>
                        </div>
                        <div class="greyAreaText1" v-if="item.status!='审核中'&&item.status!='合同待确认'">
                            <div class="greyText1" style="top: 0px;left: 0px;">吉林一号核查助手APP(V2.0.0)</div>
                            <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(3)">使用手册</div>
                            <div class="greyText3" style="top: 0px;left: 284px;" @click="isShadow=1">查看下载二维码</div>
                        </div>
                    </div>
                    <div class="greyLine1" style="left: 990px;"></div>
                    <div class="type3Shadow" v-if="item.expireStatus=='2'"></div>
                    <!-- <div v-if="item.expireStatus=='1'">
                        <div class="type3Text4">您的套件即将过期</div>
                        <div class="type3Button2"  @click="jumpEnterprise()">立即续费</div>
                        <div class="type3GreyLine"></div>
                    </div>
                    <div v-if="item.expireStatus=='2'">
                        <div class="type3Text4">您的套件已过期</div>
                        <div class="type3Button2"  @click="jumpEnterprise()">复购套件</div>
                        <div class="type3GreyLine"></div>
                    </div> -->
                    <div :class="item.expireStatus=='1' ? 'type3ButtonAll-s' : 'type3ButtonAll'" v-if="item.expireStatus!='2'">
                        <div class="geryButton1" v-if="item.status=='已付款'" style="top: 0px;right:0px;background: #0066CC;color: #FFFFFF;border:none;" @click="goviewMapSource()">查看图源</div>
                        <div class="type3Button1" v-if="item.status=='已付款'&&item.redemptionType==0" style="top: 55px;right:0px;color: #0066CC;border: 1px solid #0066CC;" @click="goRSmanage(item)">套件管理</div>
                        <div class="type3Button1" v-if="item.redemptionType==1" style="top: 55px;right:0px;color: #0066CC;border: 1px solid #0066CC;" @click="goRSmanage(item)">套件管理</div>
                        <div class="type3Button1" v-if="item.status!='审核中'&&item.status!='合同待确认'" style="top: 110px;right:0px;" @click="yuedushuoming()">使用说明</div>
                        <div class="type3Button1" v-if="item.status!='审核中'&&item.status!='合同待确认'" style="top: 165px;right:0px;" @click="openContractUrl(item.id)">查看合同</div>
                        <div class="type3Button1" v-if="item.invoiceUrl!=null&&item.invoiceUrl!=''" style="top: 220px;right:0px;" @click="openInvoice(item.invoiceUrl)">查看发票</div>
                    </div>
                    <div class="type3ButtonAll-s" v-if="item.expireStatus=='2'">
                        <div class="type3Button1" v-if="item.status!='审核中'&&item.status!='合同待确认'" style="top: 0px;right:0px;" @click="openContractUrl(item.id)">查看合同</div>
                    </div>
                    <div class="type3Button1" v-if="(item.status=='审核中'||item.status=='合同待确认')&&item.expireStatus!='2'" @click="followOrder(item.status,item.id,1)">跟踪订单</div>
                </div>
                <!--标准版(123到230行），基于专业版-->
                <div class="type3Grey" v-if="item.status!='已驳回'&&item.type==5" style="height: auto;min-height: 450px;" >
                  <img src="~@/assets/newHome/standardTitle.png" alt="" class="basisTitle" >
                  <div class="basisText1" style="color: #fff;font-weight: 400;" >{{item.repName}}</div>
                  <div class="coutyQuarterBlock">
                    <div class="coutyDashed" style="position: absolute;width: 200px;height: 70px;top: 0px;left: 900px;background-color: #F7F7F7;"></div>
                    <div class="coutyDashed" style="position: absolute;width: 200px;height: 50px;bottom: 0px;left: 900px;background-color: #F7F7F7;"></div>
                    <div class="coutyTextLeft">
                      <div class="coutyLeftText-title">{{item.repStandardList[0].subName}}</div>
                      <div class="coutyLeftText1">分辨率：{{item.repStandardList[0].resolution}}</div>
                      <div class="coutyLeftText1">有效数据覆盖率：{{item.repStandardList[0].coverRate*100}}%</div>
                      <div class="coutyLeftText1">切片等级：18级</div>
                      <div class="coutyLeftText1" style="margin-top: 25px;margin-bottom: 0;">
                        调用次数限制：{{item.repStandardList[0].flowSum/10000}}万次/日
                      </div>
                    </div>
                    <div class="orderDetailCtn">
                      <div v-if="item.postStatus=='未交付'">
                        <div class="greyAreaText1">订单编号：<span style="color: #0066CC;font-weight: 600;cursor:pointer;" @click="standardNextPage(item.id,1)">{{ item.id }}</span> </div>
                        <div class="greyAreaText1">下单时间：{{ item.createTime }}</div>
                        <div class="greyAreaText1">订单价格：￥{{ item.payFinal }} </div>
<!--                        <div class="greyAreaText1" v-if="item.status!='订单提交'&&item.status!='审核中'&&item.status!='待确认'">有效期至：{{ item.endTime }}</div>-->
<!--                        <div class="greyAreaText1" v-if="item.status!='订单提交'&&item.status!='审核中'&&item.status!='待确认'">当日剩余调用次数：<span style="color:#1E81EB;font-weight: 600;" >{{ item.todayFlowSum }}</span></div>-->
                        <div class="greyAreaText1" v-if="item.contractStatus=='合同生成中'">订单状态：审核中</div>
                        <div class="greyAreaText1" v-if="item.contractStatus=='合同已生成'">订单状态：合同已生成  &nbsp;待确认 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;" @click="followOrder(item.contractStatus,item.id,3)">去确认</span></div>
                        <div class="greyAreaText1" v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'">订单状态：合同已确认  &nbsp;待付款 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;"  @click="standardNextPage(item.id,2)">去付款</span></div>
                        <div class="greyAreaText1" v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'" style="padding-left: 70px;">( 付款完成后即刻交付 )</div>
                        <div class="greyAreaText1" v-if="item.payStatus=='已付款'">订单状态：合同已生成  &nbsp;已付款</div>
                      </div>
                      <div v-if="item.postStatus=='已交付'">
                        <div class="greyAreaText1">订单编号：<span style="color: #0066CC;font-weight: 600;cursor:pointer;" @click="standardNextPage(item.id,1)">{{ item.id }}</span></div>
                        <div class="greyAreaText1">下单时间：{{ item.createTime }}</div>
                        <!-- <div class="greyAreaText1">交付时间：{{ item.postTime }}</div> -->
                        <div class="greyAreaText1">有效期至：{{ item.endTime }}</div>
                          <div class="greyAreaText1">当日剩余调用次数：<span style="color:#1E81EB;font-weight: 600;">{{ item.todayFlowSum }}</span></div>
                        <div class="greyAreaText1">订单价格：￥{{ item.payFinal }} </div>
                        <div class="greyAreaText1" v-if="item.payStatus=='未付款'">订单状态：合同已确认  &nbsp;待付款 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;" @click="standardNextPage(item.id,2)">去付款</span></div>
                        <div class="greyAreaText1" v-if="item.payStatus=='已付款'&&item.invoiceStatus=='未开票'">订单状态：合同已确认  &nbsp;已付款 &nbsp; 未开票</div>
                        <div class="greyAreaText1" v-if="item.invoiceStatus=='已开票'&&item.evaluateStatus=='未评价'">订单状态：合同已确认  &nbsp;已付款 &nbsp;  已开票  &nbsp;<span style="color:#1E81EB ;cursor: pointer;font-weight: 600;" @click="standardNextPage(item.id,3)">去评价</span></div>
                        <div class="greyAreaText1" v-if="item.evaluateStatus=='已评价'">订单状态：已完成</div>
                        <div class="greyAreaText1" style="margin-top: 20px;">
                          <div class="greyText1" style="top: 0px;left: 0px;">Web端工具集SDK(V1.0.0)</div>
                          <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(1)">使用手册</div>
                          <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(4)">下载SDK</div>
                        </div>
                        <div class="greyAreaText1">
                          <div class="greyText1" style="top: 0px;left: 0px;">移动端工具集SDK(V1.0.0)</div>
                          <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(2)">使用手册</div>
                          <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(5)">下载SDK</div>
                        </div>
                        <div class="greyAreaText1">
                          <div class="greyText1" style="top: 0px;left: 0px;">吉林一号核查助手APP(V2.0.0)</div>
                          <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(3)">使用手册</div>
                          <div class="greyText3" style="top: 0px;left: 284px;" @click="isShadow=1">查看下载二维码</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="coutyButton">
                    <!-- 合同未确认之前 -->
                    <div class="coutyButton1" v-if="item.contractStatus=='合同生成中'||item.contractStatus=='合同已生成'" @click="standardNextPage(item.id,1,item)">跟踪订单</div>
                    <!-- 合同确认未付款未交付 -->
                    <div v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'&&item.postStatus=='未交付'">
                      <div v-if="item.expireStatus!=2" class="coutyButton2" @click="standardNextPage(item.id,2)">去付款</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="standardNextPage(item.id,1)">跟踪订单</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                    </div>
                    <!-- 已付款未交付 -->
                    <div v-if="item.payStatus=='已付款'&&item.postStatus=='未交付'">
                      <div v-if="item.expireStatus!=2" class="coutyButton1" @click="standardNextPage(item.id,1)">跟踪订单</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                    </div>
                    <!-- 已交付未付款 -->
                    <div v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'&&item.postStatus=='已交付'">
                      <div v-if="item.expireStatus!=2" class="coutyButton2"  @click="standardNextPage(item.id,2)">去付款</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="standardNextPage(item.id,1,item)">跟踪订单</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton2" style="margin-top: 15px;" @click="goviewMapSource()">查看图源</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton3" style="margin-top: 15px;" @click="goRSmanageStandard(item)">套件管理</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                    </div>
                    <!-- 已交付已付款 -->
                    <div v-if="item.payStatus=='已付款'&&item.postStatus=='已交付'">
                      <div v-if="item.expireStatus!=2" class="coutyButton2" @click="goviewMapSource()">查看图源</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="standardNextPage(item.id,1,item)">跟踪订单</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton3" style="margin-top: 15px;" @click="goRSmanageStandard(item)">套件管理</div>
                      <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType!='zp'&&item.invoiceStatus=='已开票'">查看发票</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType=='zp'&&item.invoiceExpressStatus=='已邮寄'&&item.invoiceStatus=='已开票'">查看发票</div>
                    </div>
                    <!-- 已开票 -->
                    <!--                        <div v-if="item.postStatus=='已交付'&&item.invoiceStatus=='已开票'">-->
                    <!--                            <div class="coutyButton2" @click="goviewMapSource()">查看图源</div>-->
                    <!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="standardNextPage(item.id,1)">跟踪订单</div>-->
                    <!--                            <div class="coutyButton3" style="margin-top: 15px;" @click="goviewMapSource()">套件管理</div>-->
                    <!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>-->
                    <!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>-->
                    <!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType!='zp'">查看发票</div>-->
                    <!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType=='zp'&&item.invoiceExpressStatus=='已邮寄'">查看发票</div>-->
                    <!--                        </div>-->
                  </div>
                  <div v-if="item.expireStatus==2" class="jxtShadow">

                  </div>
                </div>
                <!-- 体验版 -->
                <div class="type3Grey" style="height: 700px;" v-if="item.type==0">
                    <img src="~@/assets/newHome/体验版.png" alt="" class="basisTitle">
                    <div class="basisText1">体验版</div>
                    <div class="greyText1" style="top: 70px;">2024年全国高质量一张图</div>
                    <div class="greyText2" style="top: 100px;">分辨率：0.5m</div>
                    <div class="greyText2" style="top: 130px;">有效数据覆盖率：99%</div>
                    <div class="greyText2" style="top: 160px;">切片等级：18级</div>
                    <div class="greyText1" style="top: 210px;">2023年全国高质量一张图</div>
                    <div class="greyText2" style="top: 240px;">分辨率：0.5m</div>
                    <div class="greyText2" style="top: 270px;">有效数据覆盖率：99%</div>
                    <div class="greyText2" style="top: 300px;">切片等级：18级</div>
                    <div class="greyText1" style="top: 350px;">全球一张图</div>
                    <div class="greyText2" style="top: 380px;">分辨率：优于0.75m(含)</div>
                    <div class="greyText2" style="top: 410px;">有效数据覆盖率：100%</div>
                    <div class="greyText2" style="top: 440px;">切片等级：18级</div>
                    <!-- <div class="greyText1" style="top: 490px;">2022每季度(试点)县域一张图</div>
                    <div class="greyText2" style="top: 520px;">分辨率：优于0.75m(含)</div>
                    <div class="greyText2" style="top: 550px;">有效数据覆盖率：100%</div>
                    <div class="greyText2" style="top: 580px;">切片等级：18级</div> -->
                    <div class="greyText2" style="top: 640px;">调用次数限制：4万次/日(试用前7日内10万次/日)</div>
                    <div class="greyLine1" style="top: 60px;height: 610px;"></div>
                    <div class="greyText2" style="top: 70px;left: 556px;">申请时间：{{ item.createTime }}</div>
                    <div class="greyText2" style="top: 100px;left: 556px;">有效期：限时有效</div>
                    <div class="greyText2" style="top: 130px;left: 556px;">当日剩余调用次数：<span style="color: #1E81EB;font-weight: 600;">{{item.todayFlowSum}}</span></div>
                    <div class="greyText1" style="top: 160px;left: 556px;">Web端工具集SDK(V1.0.0)</div>
                    <div class="greyText3" style="top: 160px;" @click="getIntroction(1)">使用手册</div>
                    <div class="greyText3" style="left: 840px;top: 160px;" @click="getIntroction(4)">下载SDK</div>

                    <div class="greyText1" style="top: 190px;left: 556px;">移动端工具集SDK(V1.0.0)</div>
                    <div class="greyText3" style="top: 190px;" @click="getIntroction(2)">使用手册</div>
                    <div class="greyText3" style="left: 840px;top: 190px;" @click="getIntroction(5)">下载SDK</div>

                    <div class="greyText1" style="top: 220px;left: 556px;">吉林一号核查助手APP(V2.0.0)</div>
                    <div class="greyText3" style="top: 220px;" @click="getIntroction(3)">使用手册</div>
                    <div class="greyText3" style="left: 840px;top: 220px;" @click="isShadow=1">查看下载二维码</div>
                    <div class="greyLine2" style="left: 980px;height: 610px;"></div>
                    <div class="geryButton1" style="top: 130px;" @click="goviewMapSource()">查看图源</div>
                    <div class="geryButton"  @click="goRSmanageBasis(item)" style="top: 190px;">套件管理</div>
                    <div class="geryButton" @click="yuedushuoming()" style="top: 250px;border: 1px solid #979797;color: #3A3A3A;">使用说明</div>
                </div>
                <!-- 专业版 -->
                <!--线上-->
                <div class="type3Grey" style="height: auto;min-height: 450px;" v-if="item.status!='已驳回'&&item.type==4&&!item.offlineOrderStatus">
                    <div class="coutyIcon1">
                        <img src="~@/assets/newHome/Q4.png" alt="" style="width: 100%;height: 100%;">
                        <div class="coutyIcon1Text">专业版</div>
                    </div>
                    <div class="coutyQuarterBlock">
                        <div class="coutyDashed" style="position: absolute;width: 200px;height: 70px;top: 0px;left: 900px;background-color: #F7F7F7;"></div>
                        <div class="coutyDashed" style="position: absolute;width: 200px;height: 50px;bottom: 0px;left: 900px;background-color: #F7F7F7;"></div>
                        <div class="coutyTextLeft">
                            <div class="coutyLeftText-title">区域名称：{{ item.repCountyList[0].areaName }}</div>
                            <div class="coutyLeftText1">区域面积：<span v-if="item.repCountyList[0].area!=null">{{ item.repCountyList[0].area.toFixed(2) }}</span> km²</div>
                            <div class="coutyLeftText1">分辨率：优于0.75m(含)</div>
                            <div class="coutyLeftText3">
                              影像时间：{{ item.subNameList }}
                            </div>
                            <div class="coutyLeftText1" style="margin-bottom: 0px;">切片等级：18级</div>
                            <div v-if="item.postStatus=='已交付'" class="coutyLeftText1" style="margin-top: 25px;margin-bottom: 0;">
                              调用次数限制：{{item.flowSum/10000}}万次/日
                            </div>
                        </div>
                        <div class="orderDetailCtn">
                            <div v-if="item.postStatus=='未交付'">
                                <div class="greyAreaText1">订单编号：<span style="color: #0066CC;font-weight: 600;cursor:pointer;" @click="countyNextPage(item,1)">{{ item.id }}</span> </div>
                                <div class="greyAreaText1">下单时间：{{ item.createTime }}</div>
                                <div class="greyAreaText1">订单价格：￥{{ item.payFinal }} </div>
                                <div class="greyAreaText1" v-if="item.contractStatus=='合同生成中'">订单状态：审核中</div>
                                <div class="greyAreaText1" v-if="item.contractStatus=='合同已生成'">订单状态：合同已生成  &nbsp;待确认 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;" @click="followOrder(item.contractStatus,item.id,2)">去确认</span></div>
                                <div class="greyAreaText1" v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'">订单状态：合同已确认  &nbsp;待付款 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;"  @click="countyNextPage(item.id,2)">去付款</span></div>
                                <div class="greyAreaText1" v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'" style="padding-left: 70px;">( 付款完成后即刻交付 )</div>
                                <div class="greyAreaText1" v-if="item.payStatus=='已付款'">订单状态：合同已生成  &nbsp;已付款</div>
                            </div>
                            <div v-if="item.postStatus=='已交付'">
                                <div class="greyAreaText1">订单编号：<span style="color: #0066CC;font-weight: 600;cursor:pointer;" @click="countyNextPage(item,1)">{{ item.id }}</span></div>
                                <div class="greyAreaText1">下单时间：{{ item.createTime }}</div>
                                <!-- <div class="greyAreaText1">交付时间：{{ item.postTime }}</div> -->
                                <div class="greyAreaText1">有效期至：{{ item.endTime }}</div>
                                <div v-for="(item4, index4) in item.repCountyList" :key="index4">
                                    <div class="greyAreaText1">当日剩余调用次数({{ item4.subName }})：<span style="color:#1E81EB;font-weight: 600;">{{ item4.todayFlowSum }}</span></div>
                                </div>
                                <div class="greyAreaText1">订单价格：￥{{ item.payFinal }} </div>
                                <div class="greyAreaText1" v-if="item.payStatus=='未付款'">订单状态：合同已确认  &nbsp;待付款 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;" @click="countyNextPage(item,2)">去付款</span></div>
                                <div class="greyAreaText1" v-if="item.payStatus=='已付款'&&item.invoiceStatus=='未开票'">订单状态：合同已确认  &nbsp;已付款 &nbsp; 未开票</div>
                                <div class="greyAreaText1" v-if="item.invoiceStatus=='已开票'&&item.evaluateStatus=='未评价'">订单状态：合同已确认  &nbsp;已付款 &nbsp;  已开票  &nbsp;<span style="color:#1E81EB ;cursor: pointer;font-weight: 600;" @click="countyNextPage(item,3)">去评价</span></div>
                                <div class="greyAreaText1" v-if="item.evaluateStatus=='已评价'">订单状态：已完成</div>
                                <div class="greyAreaText1" style="margin-top: 20px;">
                                    <div class="greyText1" style="top: 0px;left: 0px;">Web端工具集SDK(V1.0.0)</div>
                                    <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(1)">使用手册</div>
                                    <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(4)">下载SDK</div>
                                </div>
                                <div class="greyAreaText1">
                                    <div class="greyText1" style="top: 0px;left: 0px;">移动端工具集SDK(V1.0.0)</div>
                                    <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(2)">使用手册</div>
                                    <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(5)">下载SDK</div>
                                </div>
                                <div class="greyAreaText1">
                                    <div class="greyText1" style="top: 0px;left: 0px;">吉林一号核查助手APP(V2.0.0)</div>
                                    <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(3)">使用手册</div>
                                    <div class="greyText3" style="top: 0px;left: 284px;" @click="isShadow=1">查看下载二维码</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="coutyButton">
                        <!-- 合同未确认之前 -->
                        <div class="coutyButton1" v-if="item.contractStatus=='合同生成中'||item.contractStatus=='合同已生成'" @click="countyNextPage(item,1)">跟踪订单</div>
                        <!-- 合同确认未付款未交付 -->
                        <div v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'&&item.postStatus=='未交付'">
                            <div v-if="item.expireStatus!=2" class="coutyButton2" @click="countyNextPage(item,2)">去付款</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="countyNextPage(item,1)">跟踪订单</div>
                            <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                        </div>
                        <!-- 已付款未交付 -->
                        <div v-if="item.payStatus=='已付款'&&item.postStatus=='未交付'">
                            <div v-if="item.expireStatus!=2" class="coutyButton1" @click="countyNextPage(item,1)">跟踪订单</div>
                            <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                        </div>
                        <!-- 已交付未付款 -->
                        <div v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'&&item.postStatus=='已交付'">
                            <div v-if="item.expireStatus!=2" class="coutyButton2"  @click="countyNextPage(item,2)">去付款</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="countyNextPage(item,1)">跟踪订单</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton2" style="margin-top: 15px;" @click="goviewMapSource()">查看图源</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton3" style="margin-top: 15px;" @click="goRSmanageCountyJudge(item)">套件管理</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>
                            <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                        </div>
                        <!-- 已交付已付款 -->
                        <div v-if="item.payStatus=='已付款'&&item.postStatus=='已交付'">
                            <div v-if="item.expireStatus!=2" class="coutyButton2" @click="goviewMapSource()">查看图源</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="countyNextPage(item,1)">跟踪订单</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton3" style="margin-top: 15px;" @click="goRSmanageCountyJudge(item)">套件管理</div>
                            <div v-if="item.expireStatus!=2" class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>
                            <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                          <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType!='zp'&&item.invoiceStatus=='已开票'">查看发票</div>
                          <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType=='zp'&&item.invoiceExpressStatus=='已邮寄'&&item.invoiceStatus=='已开票'">查看发票</div>
                        </div>
                        <!-- 已开票 -->
<!--                        <div v-if="item.postStatus=='已交付'&&item.invoiceStatus=='已开票'">-->
<!--                            <div class="coutyButton2" @click="goviewMapSource()">查看图源</div>-->
<!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="countyNextPage(item,1)">跟踪订单</div>-->
<!--                            <div class="coutyButton3" style="margin-top: 15px;" @click="goviewMapSource()">套件管理</div>-->
<!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>-->
<!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>-->
<!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType!='zp'">查看发票</div>-->
<!--                            <div class="coutyButton1" style="margin-top: 15px;" @click="openInvoiceUrl(item.invoiceUrl,item.invoiceType,item.id)" v-if="item.invoiceType=='zp'&&item.invoiceExpressStatus=='已邮寄'">查看发票</div>-->
<!--                        </div>-->
                    </div>
                    <div v-if="item.expireStatus==2" class="jxtShadow">

                    </div>
                </div>
                <!--线下-->
                <div class="type3Grey" style="height: auto;min-height: 450px;" v-if="item.status!='已驳回'&&item.type==4&&item.offlineOrderStatus">
                  <div class="coutyIcon1">
                    <img src="~@/assets/newHome/Q4.png" alt="" style="width: 100%;height: 100%;">
                    <div class="coutyIcon1Text">专业版</div>
                  </div>
                  <div class="coutyQuarterBlock">
                    <div class="coutyDashed" style="position: absolute;width: 200px;height: 70px;top: 0px;left: 900px;background-color: #F7F7F7;"></div>
                    <div class="coutyDashed" style="position: absolute;width: 200px;height: 50px;bottom: 0px;left: 900px;background-color: #F7F7F7;"></div>
                    <div class="coutyTextLeft">
                      <div class="coutyLeftText-title">区域名称(线下)：{{ item.repCountyList[0].areaName }}</div>
                      <div class="coutyLeftText1">区域面积： {{ item.repCountyList[0].area }} km²</div>
                      <div class="coutyLeftText1">分辨率：优于0.75m(含)</div>
                      <div class="coutyLeftText3">
                        影像时间：{{ item.subNameList }}
                      </div>
                      <div class="coutyLeftText1" style="margin-bottom: 0px;">切片等级：18级</div>
                      <div v-if="item.postStatus=='已交付'" class="coutyLeftText1" style="margin-top: 25px;margin-bottom: 0;">
                        调用次数限制：{{item.flowSum/10000}}万次/日
                      </div>
                    </div>
                    <div class="orderDetailCtn">
                      <div v-if="item.postStatus=='未交付'">
                        <div class="greyAreaText1">订单编号：<span style="color: #0066CC;font-weight: 600;cursor:pointer;" >{{ item.id }}</span> </div>
                        <div class="greyAreaText1">下单时间：{{ item.createTime }}</div>
                        <div class="greyAreaText1">订单价格：￥{{ item.payFinal }} </div>
                        <div class="greyAreaText1" v-if="item.contractStatus=='合同生成中'">订单状态：审核中</div>
                        <div class="greyAreaText1" v-if="item.contractStatus=='合同已生成'">订单状态：合同已生成  &nbsp;待确认 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;" @click="followOrder(item.contractStatus,item.id,2)">去确认</span></div>
                        <div class="greyAreaText1" v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'">订单状态：合同已确认  &nbsp;待付款 &nbsp; <span style="color:#1E81EB ;cursor: pointer;font-weight: 600;"  @click="countyNextPage(item,2)">去付款</span></div>
                        <div class="greyAreaText1" v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'" style="padding-left: 70px;">( 付款完成后即刻交付 )</div>
                        <div class="greyAreaText1" v-if="item.payStatus=='已付款'">订单状态：合同已生成  &nbsp;已付款</div>
                      </div>
                      <div v-if="item.postStatus=='已交付'">
                        <div class="greyAreaText1">订单编号：<span style="color: #0066CC;font-weight: 600;cursor:pointer;" >{{ item.id }}</span></div>
                        <div class="greyAreaText1">下单时间：{{ item.createTime }}</div>
                        <!-- <div class="greyAreaText1">交付时间：{{ item.postTime }}</div> -->
                        <div class="greyAreaText1">有效期至：{{ item.endTime }}</div>
                          <div class="greyAreaText1" >当日剩余调用次数：<span style="color:#1E81EB;font-weight: 600;">{{ item.todayFlowSum }}</span></div>
                        <div class="greyAreaText1">订单价格：￥{{ item.payFinal }} </div>
                        <div class="greyAreaText1" style="margin-top: 20px;">
                          <div class="greyText1" style="top: 0px;left: 0px;">Web端工具集SDK(V1.0.0)</div>
                          <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(1)">使用手册</div>
                          <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(4)">下载SDK</div>
                        </div>
                        <div class="greyAreaText1">
                          <div class="greyText1" style="top: 0px;left: 0px;">移动端工具集SDK(V1.0.0)</div>
                          <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(2)">使用手册</div>
                          <div class="greyText3" style="top: 0px;left: 284px;" @click="getIntroction(5)">下载SDK</div>
                        </div>
                        <div class="greyAreaText1">
                          <div class="greyText1" style="top: 0px;left: 0px;">吉林一号核查助手APP(V2.0.0)</div>
                          <div class="greyText3" style="top: 0px;left: 203px;" @click="getIntroction(3)">使用手册</div>
                          <div class="greyText3" style="top: 0px;left: 284px;" @click="isShadow=1">查看下载二维码</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="coutyButton">
                    <!-- 合同确认未付款未交付 -->
                    <div v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'&&item.postStatus=='未交付'">
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                    </div>
                    <!-- 已付款未交付 -->
                    <div v-if="item.payStatus=='已付款'&&item.postStatus=='未交付'">
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                    </div>
                    <!-- 已交付未付款 -->
                    <div v-if="item.contractStatus=='用户已确认'&&item.payStatus=='未付款'&&item.postStatus=='已交付'">
                      <div class="coutyButton2" style="margin-top: 15px;" @click="goviewMapSource()">查看图源</div>
                      <div class="coutyButton3" style="margin-top: 15px;" @click="goRSmanageCountyJudge(item)">套件管理</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                    </div>
                    <!-- 已交付已付款 -->
                    <div v-if="item.payStatus=='已付款'&&item.postStatus=='已交付'">
                      <div class="coutyButton2" @click="goviewMapSource()">查看图源</div>
                      <div class="coutyButton3" style="margin-top: 15px;" @click="goRSmanageCountyJudge(item)">套件管理</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="yuedushuoming()">使用说明</div>
                      <div class="coutyButton1" style="margin-top: 15px;" @click="openContractUrlCounty(item.contractUrl)">查看合同</div>
                    </div>
                  </div>
                  <div v-if="item.expireStatus==2" class="jxtShadow"></div>
                </div>
                <div class="type3Grey" style="height: auto;min-height: 450px;" v-if="item.status=='已驳回'&&item.type==4">
                    <div class="coutyIcon1">
                        <img src="~@/assets/newHome/过期企业版(全版本).png" alt="" style="width: 100%;height: 100%;">
                        <div class="coutyIcon1Text">专业版</div>
                    </div>
                    <div class="coutyBlock" style="border-right: 1px dashed rgba(151, 151, 151,0.5);">
                        <div class="coutyDashed" style="position: absolute;width: 200px;height: 43px;top: 27px;left: 900px;background-color: #F7F7F7;"></div>
                        <div class="coutyDashed" style="position: absolute;width: 200px;height: 50px;bottom: 0px;left: 900px;background-color: #F7F7F7;"></div>
                        <div class="coutyTextLeft" style="opacity: 0.5;">
                            <div class="coutyLeftText1" style="color: #777777;">区县名称：{{ item.repCountyList[0].areaName }}</div>
                            <div class="coutyLeftText1">区县面积：{{ item.repCountyList[0].area }} km²</div>
                            <div class="coutyLeftText1">分辨率：优于0.75m(含)</div>
                            <div class="coutyLeftText1" style="margin-bottom: 0px;">切片等级：18级</div>
                            <div v-for="(item7, index7) in item.repCountyList" :key="index7">
                                <div class="coutyLeftText2" v-if="item7.sort===1">2023年第一季度区/县一张图</div>
                                <div class="coutyLeftText2" v-if="item7.sort===2">2023年第二季度区/县一张图</div>
                                <div class="coutyLeftText2" v-if="item7.sort===3">2023年第三季度区/县一张图</div>
                                <div class="coutyLeftText2" v-if="item7.sort===4">2023年第四季度区/县一张图</div>
                                <div class="coutyLeftText1" style="margin-bottom: 0;margin-top: 10px;">有效数据覆盖率：{{ item7.coverRate*100 }}%</div>
                            </div>
                            <div class="coutyLeftText2" style="margin-bottom: 10px;">全球一张图</div>
                            <div class="coutyLeftText1">分辨率：优于0.75m(含)</div>
                            <div class="coutyLeftText1">有效数据覆盖率：100%</div>
                            <div class="coutyLeftText1">切片等级：18级</div>
                            <div class="coutyLeftText1" style="margin-top: 25px;margin-bottom: 0;">调用次数限制：50万次/日</div>
                        </div>
                        <div class="greyArea1">
                            <div class="greyAreaText1">订单编号：<span style="color: #0066CC;font-weight: 600;cursor:pointer;" @click="countyNextPage(item,1)">{{ item.id }}</span></div>
                            <div class="greyAreaText1">下单时间：{{ item.createTime }}</div>
                            <div class="greyAreaText1">订单状态：审核未通过</div>
                            <div class="greyAreaText1" style="padding-left: 28px;height: auto;">原因：/*商务经理在管理端给出原因*/</div>
                        </div>
                    </div>
                    <div class="coutyButton">
                        <div class="coutyButton1" @click="deleteCounty(item.id)">删除订单</div>
                    </div>
                </div>
            </div>
            <div class="buyAgain">
                <div style="position: absolute;top: 0px;left: calc(50% - 640px); width: 1280px;height: 500px;">
                    <!-- <div class="text1">调用面积或次数不够用？请增购企业版</div> -->
                    <img src="~@/assets/newHome/查看价格.png" alt="" class="baseImg1">
                    <div class="text2">想详细了解各版本的细则和权益？</div>
                    <div class="text3"  @click="$router.push('/Price');">点击查看 ></div>
                    <div class="noRsButton2" style="left: calc(50% + 15px);" @click="orderStatus()">选购专业版</div>
                    <div class="noRsButton2" style="left: calc(50% - 315px);" @click="buyStandard()">选购标准版</div>
                </div>
            </div>
        </div>
        <img src="~@/assets/newHome/提问.png" alt="" class="problemImg" @click="getProblem=!getProblem">
        <img src="~@/assets/newHome/二维码.png" alt="" class="erweimaImg" v-if="getProblem">
        <div class="shadow" v-if="isShadow==1">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowText1">请使用手机浏览器扫描下方二维码<br>下载吉林一号核查助手APP</div>
                <img src="~@/assets/newHome/安卓二维码.png" alt="" class="erweima1">
                <img src="~@/assets/newHome/ios二维码.png" alt="" class="erweima1" style="left: 425px;">
                <div class="shadowButton" @click="isShadow=0">确定</div>
            </div>
        </div>
        <div class="shadow" v-if="isShadow==2">
            <div class="shadowContent2">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowText1">请选择您的专业版套件</div>
                <div class="shadowCount-s">
                    <div class="shadowCountyButton-s" v-for="(item, index) in repCountyList" :key="'repCountyList'+index" @click="goRSmanageCounty(item,repCountyTime)">{{ item.subName }}</div>
                </div>
            </div>
        </div>
        <div class="shadow" v-if="isShadow==4">
            <div class="shadowContent2">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowText2" style="font-size:20px;text-align: center;">订单 {{ invoiceMeg.requirementId }} 发票寄送信息</div>
                <div class="shadowText2" style="top:140px;left:150px;">快递信息：{{ invoiceMeg.expressCompany }}</div>
                <div class="shadowText2" style="top:220px;left:150px;">物流订单：{{ invoiceMeg.expressId }}</div>
                <div class="shadowButton" @click="isShadow=0" style="top:310px;">确定</div>
            </div>
        </div>
    </div>
  </template>

  <script>
    import {rootUrl} from '@/globalConfig'

  export default {
    name: "MyRSservices",
    data() {
      return {
        freebackShow:true,
        id:"",
        dataList:[],
        remainAreaList:[],
        //判断企业版是否有未完成订单
        unOKOrder:false,
        //未完成订单id和status
        unOKId:'',
        unOKStatus:'',
        rsNum:0,
        getProblem:false,
        isShadow:0,
        repCountyList:[],
        repCountyTime:'',
        invoiceMeg:'',
      };
    },
    methods: {
        //实名权限检查与处理（遥感商城版）
        checkAndHandleAuthentication(){
          console.log("进入实名检查")
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            this.jumpWithPermission('仅实名','/Login','/rskit/MyRSservices')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/MyRSservices')
          }
          return true;
        },
        //带权限判断的跳转
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        getKey() {
            return localStorage.getItem("token");
        },
        getHeight(){
            let enterpriseId = document.getElementById("enterpriseId")
            enterpriseId.style.height= "1800px"
        },
        orderList(){
            this.axios.post("/tilesapi/tiles/register/queryTileOrderList",null, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res)=>{
                let data = res.data.data
                console.log(data);
                if(data.length>0){
                    let repository_ids=data[0].repositoryId
                    for(let i=1;i<data.length;i++){
                        repository_ids=repository_ids+','+ data[i].repositoryId
                    }
                    this.getRemainAreaByReps(repository_ids)
                    this.dataList=data
                    for(let i=0;i<data.length;i++){
                        if(data[i].repCountyList!=null){
                            let subNameList = []
                            for(let j=0;j<data[i].repCountyList.length;j++){
                                subNameList.push(data[i].repCountyList[j].subName)
                            }
                            subNameList=subNameList.join('、')
                            this.dataList[i]={ ...this.dataList[i], subNameList: subNameList }
                        }
                    }
                    this.rsNum=data.length
                    if(this.rsNum<=2){
                        this.getHeight()
                    }
                    for(let i=0;i<data.length;i++){
                        if(data[i].type==1){
                            if(data[i].status!='已付款'){
                                this.unOKOrder=true
                                this.unOKId=data[i].id
                                this.unOKStatus=data[i].status
                                return
                            }
                        }
                    }
                }
            })
        },
        //获取剩余面积额度
        getRemainAreaByReps(repository_ids){
            let data=new FormData();
            data.append("repository_ids",repository_ids)
            this.axios.post("/map_service_back/program/getRemainAreaByReps",data,{
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                }
                }).then((res) => {
                    console.log(res)
                    this.remainAreaList=res.data.data
                });
        },
        //跟踪订单
        followOrder(status,id,type){
            if(type==1){
                if(status=='审核中'){
                    this.$router.push({path: "/Process",query: {'id':id}});
                }else if(status=='合同待确认'){
                    this.$router.push({path: "/Contract",query: {'id':id}});
                }
            }else if(type==2){
                if(status=='合同生成中'){
                    this.$router.push({path: "/rsOrderDetail",query: {'orderId':id}});
                }else if(status=='合同已生成'){
                    this.$router.push({path: "/countyContract",query: {'id':id}});
                }
            }else if(type==3){
              if(status=='合同生成中'){
                this.$router.push({path: "/Process",query: {'id':id}});
              }else if(status=='合同已生成'){
                this.$router.push({path: "/standardContract",query: {'id':id}});
              }
            }

        },
        //查看合同企业版
        openContractUrl(id){
            let inputForm = new FormData();
            inputForm.append("id",id);
            this.axios.post("/tilesapi/tiles/contract/queryContractByOrderId",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    let data = res.data.data
                    let url = data.url
                    window.open(url)
                })

        },
        //查看合同区县版
        openContractUrlCounty(url){
            window.open(url)
        },
        //查看发票
        openInvoiceUrl(url,invoiceType,id){
            if(invoiceType!='zp'){
                window.open(url)
            }else{
                let requestData=new FormData();
                requestData.append("requirementId",id)
                this.axios.post("/accessapi/invoice/getInvoiceDeliveryInfo",
                    requestData,
                    {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    }
                    }
                ).then((res) => {
                    console.log(res)
                    this.invoiceMeg=res.data.data;
                    });
                this.isShadow=4;
            }
        },
        //标准版跳转
        goRSmanageStandard(item){
          this.$store.state.repositoryId=item.repStandardList[0].repositoryId
          this.$store.state.createTime=item.createTime
          this.$store.state.item=item
          console.log(this.$store.state.repositoryId,this.$store.state.createTime,this.$store.state.item)
          this.$router.push("/RSsserviceManage");
        },
        goRSmanageBasis(item){
            this.$store.state.repositoryId=item.repositoryId
            this.$store.state.createTime=item.createTime
            this.$store.state.item=item
            this.$router.push("/RSsserviceManage");
        },
        goRSmanage(item){
            this.$store.state.repositoryId=item.id
            this.$store.state.createTime=item.createTime
            this.$store.state.item=item
            this.$router.push("/RSsserviceManage");
        },
        goRSmanageCounty(item,time){
            this.$store.state.repositoryId=item.repositoryId
            this.$store.state.createTime=time
            this.$store.state.subName=item.subName
            this.$router.push("/RSsserviceManage");
        },
        goRSmanageCountyJudge(item){
            console.log("套件管理：",item)
            this.$store.state.item=item
            if(item.repCountyList.length==1){
                this.goRSmanageCounty(item.repCountyList[0],item.createTime)
            }else {
                this.repCountyList=item.repCountyList
                this.repCountyTime = item.createTime
                this.isShadow=2
            }
        },
        getUserData(){
            if(this.$store.state.county.name==''||this.$store.state.county.name==null){
                return false
            }else if(this.$store.state.county.age==''||this.$store.state.county.age==null){
                return false
            }else if(this.$store.state.county.sex==''||this.$store.state.county.sex==null){
                return false
            }else if(this.$store.state.county.company==''||this.$store.state.county.company==null){
                return false
            }else if(this.$store.state.county.education==''||this.$store.state.county.education==null){
                return false
            }else{
                return true
            }
        },
        orderStatus(){
            this.axios.post("/tilesapi/tiles/register/queryTileOrderStatus",null, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res)=>{
                let data = res.data.data
                if(!data.includes('体验版')){
                    if(!this.getUserData()){
                        this.$router.push({path: "/Purchase",query: {'processType':7}});
                    }else{
                        this.$router.push('/buyCountyProduction');
                    }
                }else{
                    if(!this.getUserData()){
                        this.$router.push({path: "/Purchase",query: {'processType':8}});
                    }else{
                        this.$router.push('/buyCountyProduction');
                    }
                }
            })
        },
        buyStandard(){
          this.$router.push({path: "/Purchase",query: {'processType':11}})
        },
        getIntroction(i){
            if(i==1){
                window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6Web%E7%AB%AF%E5%B7%A5%E5%85%B7%E9%9B%86SDK_V1.0.0_%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
            }else if(i==2){
                window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6%E7%A7%BB%E5%8A%A8%E7%AB%AF%E5%B7%A5%E5%85%B7%E9%9B%86SDK_V1.0.0_%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
            }else if(i==3){
                window.open("https://files.jl1mall.com/tiles/使用手册/吉林一号核查助手APP_V2.0.0_使用说明书.pdf")
            }else if(i==4){
                window.open("https://files.jl1mall.com/tiles/sdk/吉林一号切片影像套件Web端工具集SDK_V1.0.0.zip")
            }else if(i==5){
                window.open("https://files.jl1mall.com/tiles/sdk/吉林一号切片影像套件移动端工具集SDK_V1.0.0.zip")
            }
        },
        yuedushuoming(){
            window.open("https://files.jl1mall.com/使用手册/吉林一号切片影像套件服务V1.21使用说明书.pdf")
        },
        goviewMapSource(){
            this.$router.push("/viewMapSource");
        },
        goviewMapSourceCounty(repCounty,time){
            console.log(repCounty);
            this.$store.state.repositoryId=repCounty.repositoryId
            this.$store.state.createTime=time
            this.$store.state.repositoryType=2
            this.$store.state.repositorySort=repCounty.sort
            this.$store.state.repositoryName=repCounty.areaName+repCounty.subName
            this.$router.push("/viewMapSource");
        },
        deleteCounty(id){
            let inputForm = new FormData();
            inputForm.append("orderId",id);
            this.axios.post("/tilesapi/tiles/county/order/deleteRejectCountyOrder",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    console.log(res);
                    if(res.data.code==200){
                        this.orderList()
                    }else{
                        alert("删除订单失败，请联系商务经理（0431-86008580）")
                    }
                })
        },
        countyNextPage(item,type){
            //type 1去订单详情页  2去支付页面  3去评价页面
            if(type==1){
                this.$store.state.item=item
                this.$router.push({path: "/rsOrderDetail",query: {'orderId':item.id}})
            }else if(type==2){
                this.$router.push({name: "rsOrderPayment",params: {'orderId':item.id}})
            }else if(type==3){
                this.$router.push({name: "rsOrderAppraise",params: {'orderId':item.id}})
            }
        },
      standardNextPage(id,type,item){
        //type 1去订单详情页  2去支付页面  3去评价页面
        if(type==1){
          this.$store.state.item=item
          this.$router.push({path: "/rsStandardOrderDetail",query: {'orderId':id}})
        }else if(type==2){
          this.$router.push({name: "standardOrderPayment",params: {'orderId':id}})
        }else if(type==3){
          this.$router.push({name: "rsOrderAppraise",params: {'orderId':id}})
        }
      },
        openInvoice(url){
            window.open(url)
        }
    },
    mounted() {
        document.getElementById('barId').scrollIntoView({ behavior: "instant"});
        if(this.checkAndHandleAuthentication()){
            this.orderList()
        }
    },
    computed: {

    },
  };
  </script>

  <style scoped>
    .bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.freeback{
    position: relative;
    width: 100%;
    height: 40px;
    background: #0066CC;
}
.freebackBlue{
    position: absolute;
    width: 1920px;
    height: 40px;
}
.freebackText{
    position: absolute;
    left:50%;
    transform:translate(-50%,0);
    width: 800px;
    height:40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height:40px;
    text-align: center;
    z-index: 1;
}
.freebackClose{
    position: absolute;
    width: 14px;
    height: 14px;
    right: 50px;
    top: 13px;
    cursor: pointer;
}
.navi{
    position: relative;
    width: 100%;
    height: 40px;
    background: #F5F5F6;
}
.naviContent{
    position: absolute;
    width: 1920px;
    height: 40px;
    left: calc(50% - 960px);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 40px;
    padding-left: 120px;
}
.zhanwei{
    position: relative;
    width: 100%;
    height: 800px;
    background-color: #fff;
}
.NoRs{
    position: relative;
    width: 100%;
    height: 800px;
    background-color: #fff;
}
.text1{
    position: absolute;
    top: 75px;
    left: calc(50% - 400px);
    width: 800px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;

}
.baseImg1{
    position: absolute;
    top: 167px;
    left: calc(50% - 13px);
    width: 26px;
    height: 26px;
}
.text2{
    position: relative;
    top: 211px;
    left: calc(50% - 150px);
    width: 300px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
}
.text3{
    position: absolute;
    top: 245px;
    left: calc(50% - 50px);
    width:100px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1E81EB;
line-height: 22px;
text-align: center;
cursor: pointer;
}
.noRsButton1-s{
    position: absolute;
    top: 342px;
    left: calc(50% - 160px);
    width: 320px;
    height: 52px;
    background: #3A3A3A;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    text-align: center;
    cursor: pointer;
}
.noRsButton1{
    position: absolute;
    top: 342px;
    left: calc(50% - 337px);
    width: 320px;
    height: 52px;
    background: #3A3A3A;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    text-align: center;
    cursor: pointer;
}
.noRsButton2{
    position: absolute;
    top: 342px;
    left: calc(50% + 2px);
    width: 310px;
    height: 52px;
    background: linear-gradient(107deg, #54A7FF 0%, #1E81EB 100%);
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    cursor: pointer;
    text-align: center;
}
.basis{
    position: relative;
    width: 100%;
    height: 1200px;
    background-color: #fff;
}
.basisTitle{
    position: absolute;
    top: -9px;
    left: calc(50% - 201px);
    width: 402px;
    height: 42px;
    z-index: 1;
}
.coutyIcon1{
    position: absolute;
    top: -9px;
    left: calc(50% - 201px);
    width: 402px;
    height: 42px;
    z-index: 1;
}
.coutyIcon1Text{
    position: absolute;
    top: 0;
    width: 402px;
    height: 42px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #3a3a3a;
    text-align: center;
    line-height: 42px;
}
.coutyIcon2{
    position: absolute;
    top: -9px;
    left: calc(50% - 350px);
    width: 700px;
    height: 42px;
    z-index: 1;
}
.coutyIcon21{
    position: absolute;
    top: 0;
    left: 0;
    width: 400px;
    height: 42px;
    z-index: 1;
}
.coutyIcon22{
    position: absolute;
    top: 0;
    left: 300px;
    width: 400px;
    height: 42px;
    z-index: 1;
}
.coutyIcon3{
    position: absolute;
    top: -9px;
    left: calc(50% - 500px);
    width: 1000px;
    height: 42px;
    z-index: 1;
}
.coutyIcon33{
    position: absolute;
    top: 0;
    left: 600px;
    width: 400px;
    height: 42px;
    z-index: 1;
}
.coutyIcon4{
    position: absolute;
    top: -9px;
    left: calc(50% - 650px);
    width: 1300px;
    height: 42px;
    z-index: 1;
}
.coutyIcon44{
    position: absolute;
    top: 0;
    left: 900px;
    width: 400px;
    height: 42px;
    z-index: 1;
}
.coutyBlock{
    position: relative;
    width: 980px;
    height: auto;
    padding-bottom: 50px;
    /* overflow: hidden; */
    border-right: 1px dashed #979797;
    border-top: 1px dashed transparent;
}
    .coutyQuarterBlock {
      display: flex;
      justify-content: flex-start;
      position: relative;
      width: 980px;
      height: auto;
      padding-bottom: 50px;
      /* overflow: hidden; */
      border-right: 1px dashed #979797;
      border-top: 1px dashed transparent;
    }
    .orderDetailCtn{
      margin-top: 70px;
      margin-left: 70px;
      width: 390px;
      height: auto;
      min-height: 300px;
      top: 70px;
    }
.coutyTextLeft{
    margin-top: 70px;
    margin-left: 120px;
    width: 363px;
    height: auto;
    border-right:1px dashed #979797;
    overflow: hidden;
    /* background-color: green; */
}
.coutyLeftText1{
    margin-bottom: 10px;
    width: 360px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
}
.coutyLeftText2{
    margin-top: 25px;
    width: 360px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 20px;
}
.coutyLeftText3{
  margin-bottom: 10px;
  width: 340px;
  height: auto;
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
}
.coutyLeftText-title{
  margin-bottom: 10px;
  width: 360px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #000000;
  font-weight: bold;
  line-height: 20px;
}
.coutyButton{
    position: absolute;
    right: 100px;
    top: 50%;
    transform: translate(0, -50%);
    width: 100px;
    height: auto;
}
.coutyButton1{
    width: 100px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #3A3A3A;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 40px;
    cursor: pointer;
    text-align: center;

}
.coutyButton2{
    width: 100px;
    height: 40px;
    background: #0066CC;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
}
.coutyButton3{
    width: 100px;
height: 40px;
border-radius: 8px;
border: 1px solid #0066CC;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #0066CC;
line-height: 40px;
    cursor: pointer;
    text-align: center;
}
.basisText1{
    position: absolute;
    top: 0px;
    left: calc(50% - 200px);
    width: 400px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
    z-index: 2;
}
.reServiceStart{
    position: absolute;
    top: 45px;
    left: calc(50% - 163px);
    width: 326px;
height: 32px;
background: #FFFFFF;
border-radius: 8px;
border: 1px solid #979797;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #777777;
line-height: 32px;
text-align: center;
}
.basisGrey{
    position: absolute;
    top: 199px;
    left: calc(50% - 640px);
    width: 1280px;
height: 420px;
background: #F7F7F7;
border-radius: 16px;
}
.greyText1{
    position: absolute;
    top: 209px;
    left: 120px;
    width: 300px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 20px;
}
.greyText2{
    position: absolute;
    top: 149px;
    left: 120px;
    width: 400px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
}
.greyText2-s{
    position: absolute;
    top: 149px;
    left: 120px;
    width: 400px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
    background: linear-gradient(124deg, #FF914F 0%, #FF391D 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
}
.greyArea1{
    position: absolute;
    width: 390px;
    height: 470px;
    top: 70px;
    left: 555px;
}

.greyAreaText1{
    position: relative;
    margin-bottom: 10px;
    width: 380px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
}
.greyAreaText1-s{
    margin-bottom: 10px;
    /* position: relative; */
    width: 380px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #777777;
    line-height: 20px;
    background: linear-gradient(124deg, #FF914F 0%, #FF391D 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.greyText3{
    position: absolute;
    top: 299px;
    left: 759px;
    width:120px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1E81EB;
line-height: 20px;
cursor: pointer;
}
.greyLine1{
    position: absolute;
    top: 60px;
    left: 480px;
    width: 2px;
    height: 605px;
    border-right:1px dashed #979797;
    opacity: 0.7;
}
.type3Shadow{
    position: absolute;
    width:1000px;
    height: 586px;
    background: #F7F7F7;
    border-radius: 16px;
    opacity: 0.7;
    }
.jxtShadow{
  position: absolute;
  top:-5px;
  left:1px;
  width:1000px;
  height: 100%;
  background: #F7F7F7;
  border-radius: 16px;
  opacity: 0.7;
  z-index: 20;
}
.greyLine2{
    position: absolute;
    top: 60px;
    right: 299px;
    width: 2px;
    height: 310px;
    border-right: 1px dashed #979797;
    opacity: 0.7;
}
.geryButton{
    position: absolute;
    top: 220px;
    right: 100px;
    width: 100px;
    height: 40px;
    border-radius: 8px;
border: 1px solid #0066CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
color: #0066CC;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.geryButton1{
    position: absolute;
    top: 250px;
    right: 100px;
    width: 100px;
height: 40px;
background: #0066CC;
border-radius: 8px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 40px;
cursor: pointer;
text-align: center;
}
.enterprise{
    position: relative;
    width: 100%;
    height: auto;
    background-color: #fff;
}
.textType3{
    margin-top: 75px;
    margin-left: calc(50% - 200px);
    margin-bottom: 82px;
    width: 400px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}

.type3Grey{
    position: relative;
    /* padding-top: 1px; */
    border-top: 1px solid transparent;
    margin-bottom: 82px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 720px;
    background: #F7F7F7;
    border-radius: 16px;

    /* overflow: hidden; */
}

.type3Text4{
    position: absolute;
    top: 121px;
    left: 1074px;
    width: 120px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 20px;
    background: linear-gradient(124deg, #FF914F 0%, #FF391D 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.type3Button2{
    position: absolute;
    top: 159px;
    right: 100px;
    width: 100px;
height: 40px;
background: #FF4040;
border-radius: 8px;
border: 1px solid #FF4040;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.type3GreyLine{
    position: absolute;
    top: 228px;
    right: 100px;
    width: 100px;
    height: 1px;
    border-top:1px dashed #979797;
    opacity: 0.7;
}
.type3ButtonAll{
    position: absolute;
    top: 180px;
    right: 100px;
    width: 100px;
    height: 300px;
}
.type3ButtonAll-s{
    position: absolute;
    top: 259px;
    right: 100px;
    width: 100px;
    height: 300px;
}
.type3Button1{
    position: absolute;
    top: 310px;
    right: 100px;
    width: 100px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #3a3a3a;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #3a3a3a;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.buyAgain{
    position: relative;
    margin-top: -50px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 586px;
    /* background-color: powderblue; */
}
.problemImg{
    position: fixed;
    top: 231px;
    right: 59px;
    z-index: 100;
    width: 58px;
    height: 58px;
    cursor: pointer;
}
.erweimaImg{
    position: fixed;
    top: 279px;
    right: 60px;
width: 164px;
height: 264px;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 240px);
    left: calc(50% - 400px);
    width: 800px;
    height: 480px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowContent2{
    position: fixed;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    min-height: 400px;
    background: #FFFFFF;
    border-radius: 12px;
    height:auto;
}
.shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 150px);
    width: 300px;
height: 60px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 30px;
text-align: center;
}
.shadowText2{
    position: absolute;
    top: 50px;
    left: calc(50% - 400px);
    width: 800px;
height: 60px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 30px;
text-align: left;
}
.erweima1{
    position: absolute;
    top: 140px;
    left: 175px;
    width: 200px;
height: 200px;
}
.shadowButton{
    position: absolute;
    top: 387px;
    left: calc(50% - 48px);
    width: 92px;
height: 40px;
background: #0066CC;
border-radius: 6px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.shadowCount{
    position: absolute;
    top: 180px;
    width: 315px;
    left: calc(50% - 157px);
    height: 44px;
}
.shadowCount-s{
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%,-35%);
    width:640px;
    min-height: 44px;
    height:auto;
}
.shadowCountyButton-s{
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 15px;
    width: 200px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #3A3A3A;
    line-height: 44px;
    cursor: pointer;
    text-align: center;
}

.shadowCountyButton{
    position: absolute;
    top: 0px;
    left: 0;
    width: 150px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #3A3A3A;
    line-height: 44px;
    cursor: pointer;
    text-align: center;
}
  </style>
